<template>
  <div :class="$style.loadingScreen">
    <div :class="$style.loadingContainer">
      <div :class="$style.loadingLogo">
        <img src="@/assets/images/linkooklive_longlogo.png" alt="Linkook logo" />
      </div>
      <div :class="$style.loadingSpinner">
        <div :class="$style.spinner"></div>
      </div>
      <div :class="$style.loadingText">
        <h2>{{ loadingText }}</h2>
      </div>
      <div :class="$style.loadingDots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingScreen",
  props: {
    loadingText: {
      type: String,
      default: "데이터를 불러오는 중...",
    },
  },
};
</script>

<style module>
.loadingScreen {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
  background: white;
  font-family: "NanumSquareRoundR", sans-serif;
}

.loadingContainer {
  text-align: center;
  padding: 80px 60px;
  max-width: 700px;
  width: 100%;
}

.loadingLogo {
  margin-bottom: 30px;
}

.loadingLogo img {
  width: 250px;
  height: auto;
}

.loadingSpinner {
  margin-bottom: 30px;
}

.spinner {
  width: 100px;
  height: 100px;
  border: 6px solid #f3f3f3;
  border-top: 6px solid #222;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loadingText h2 {
  color: #333;
  font-size: 32px;
  font-weight: bold;
  margin: 0 0 20px 0;
  font-family: "NanumSquareRoundB", sans-serif;
}

.loadingDots {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 8px;
}

.loadingDots span {
  width: 16px;
  height: 16px;
  background: #222;
  border-radius: 50%;
  animation: dots 1.4s ease-in-out infinite both;
}

.loadingDots span:nth-child(1) {
  animation-delay: -0.32s;
}

.loadingDots span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes dots {

  0%,
  80%,
  100% {
    transform: scale(0);
    opacity: 0.5;
  }

  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* ========================================
   반응형 디자인
   - Large: 1025px ~ (기본 스타일)
   - Medium: 481px ~ 1024px
   - Small: ~ 480px
   ======================================== */

/* Medium (481px ~ 1024px) */
@media screen and (max-width: 1024px) {
  .loadingScreen {
    min-height: 60vh;
  }

  .loadingContainer {
    padding: 60px 40px;
    max-width: 600px;
  }

  .loadingLogo {
    margin-bottom: 25px;
  }

  .loadingLogo img {
    width: 220px;
  }

  .loadingSpinner {
    margin-bottom: 25px;
  }

  .spinner {
    width: 80px;
    height: 80px;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #222;
  }

  .loadingText h2 {
    font-size: 24px;
    margin: 0 0 15px 0;
  }

  .loadingDots {
    margin-top: 25px;
    gap: 7px;
  }

  .loadingDots span {
    width: 14px;
    height: 14px;
  }
}

/* Small (~ 480px) */
@media screen and (max-width: 480px) {
  .loadingScreen {
    min-height: 50vh;
  }

  .loadingContainer {
    padding: 40px 20px;
    max-width: 100%;
  }

  .loadingLogo {
    margin-bottom: 20px;
  }

  .loadingLogo img {
    width: 160px;
  }

  .loadingSpinner {
    margin-bottom: 20px;
  }

  .spinner {
    width: 60px;
    height: 60px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #222;
  }

  .loadingText h2 {
    font-size: 16px;
    margin: 0 0 12px 0;
  }

  .loadingDots {
    margin-top: 20px;
    gap: 6px;
  }

  .loadingDots span {
    width: 10px;
    height: 10px;
  }
}
</style>
